import api from "./axios";

export const loginOTP = async (data) => {
    try {
        const response = await api.post(`/api/v1/user/login/otp`, data);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong")
    }
}

export const login = async (data) => {
    try {
        const response = await api.post(`/api/v1/user/login`, data);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong")
    }
}
export const getVerifyToken = async (token) => {
    try {
        const response = await api.get(`/api/v1/user/verify/${token}`);
        return response.data;
    } catch (error) {
        console.error(error.response?.data?.message || "Something went wrong")
    }
}